<script lang="ts" setup>
import { getAppUrl } from '@/lib/helpers'

const menu: {
  text: string
  url: string
}[] = [
  {
    text: 'O platformie',
    url: '/#wszystko-w-jednym-miejscu',
  },
  {
    text: 'Dla kogo',
    url: '/#dla-kogo',
  },
  {
    text: 'Dołącz do nas',
    url: '/#zostan-czescia',
  },
  {
    text: 'Opinie',
    url: '/#opinie',
  },
  {
    text: 'FAQ',
    url: '/#faq',
  },
]

function isInternal(url: string) {
  return url.startsWith('/')
}

const drawer = shallowRef(false)

const drawerWidth = ref(320)

onMounted(() => {
  drawerWidth.value = window.innerWidth

  window.addEventListener('resize', () => {
    drawerWidth.value = window.innerWidth
  })
})

const hasScrolled = ref(false)

onMounted(() => {
  const handleScroll = () => {
    hasScrolled.value = window.scrollY > 100
  }

  window.addEventListener('scroll', handleScroll, { passive: true })
  handleScroll()

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })
})
</script>

<template>
  <v-app-bar
    :height="$vuetify.display.mdAndUp ? 80 : 54"
    flat
    color="transparent"
    :style="{
      background: ($vuetify.display.smAndDown && hasScrolled) || drawer ? 'rgba(242, 243, 247, 0.8) !important' : 'transparent',
      transition: 'color 0.3s ease, background 0.3s ease',
      backdropFilter: ($vuetify.display.smAndDown && hasScrolled) || drawer ? 'blur(8px)' : undefined,
    }"
  >
    <v-container class="d-flex align-center justify-center h-100">
      <div class="d-flex align-center justify-center ga-3 w-100">
        <v-app-bar-nav-icon
          v-if="$vuetify.display.smAndDown"
          variant="outlined"
          border
          :color="hasScrolled || drawer ? undefined : 'white'"
          :min-width="0"
          :width="52"
          :height="32"
          rounded="xll"
          @click="drawer = !drawer"
        />
        <div
          class="d-flex align-center justify-center px-md-8"
          :style="{
            height: '48px',
            borderRadius: '48px',
            transition: 'color 0.3s ease, background 0.3s ease',
            backdropFilter: $vuetify.display.mdAndUp ? 'blur(8px)' : undefined,
            color: hasScrolled || drawer ? undefined : '#fff',
          }"
        >
          <ui-logo
            class="text-inherit"
            :style="{ width: '110px' }"
          />
        </div>
        <div
          v-if="$vuetify.display.mdAndUp"
          class="d-flex align-center ga-1 px-md-8"
          :style="{
            position: 'absolute',
            borderRadius: '48px',
            background: 'rgba(242, 243, 247, 0.8) !important',
            backdropFilter: 'blur(8px)',
          }"
        >
          <v-btn
            v-for="item in menu"
            :key="item.text"
            :to="isInternal(item.url) ? item.url : undefined"
            :href="!isInternal(item.url) ? item.url : undefined"
            :target="!isInternal(item.url) ? '_blank' : undefined"
            :rel="!isInternal(item.url) ? 'noopener' : undefined"
            :text="item.text"
            variant="text"
            exact
            :active="false"
          />
        </div>

        <v-spacer />

        <v-btn
          v-if="$vuetify.display.mdAndUp"
          :color="!hasScrolled ? 'white' : 'primary'"
          :variant="!hasScrolled ? 'tonal' : 'flat'"
          rounded="xll"
          :href="getAppUrl()"
          :style="{
            background: hasScrolled ? 'rgba(var(--v-theme-primary-900), 0.8) !important' : undefined,
            backdropFilter: 'blur(8px)',
          }"
        >
          <template v-if="$auth.user">
            <div class="d-flex flex-row align-center ga-2 mx-n3">
              <v-avatar size="32">
                <v-img v-if="$auth.user.avatar" :src="$auth.user.avatar" />
                <span v-else v-text="$auth.user.initials" />
              </v-avatar>
              <div class="mr-1 text-truncate">
                {{ $auth.user.firstname }} {{ $auth.user.lastname }}
              </div>
            </div>
          </template>
          <template v-else>
            Zaloguj się
          </template>
        </v-btn>

        <v-btn
          v-if="$vuetify.display.smAndDown"
          variant="outlined"
          :color="hasScrolled || drawer ? undefined : 'white'"
          rounded="xll"
          :href="getAppUrl()"
          size="x-small"
        >
          <template v-if="$auth.user">
            <div class="d-flex flex-row align-center ga-2 mx-n2">
              <v-avatar size="24">
                <v-img v-if="$auth.user.avatar" :src="$auth.user.avatar" />
                <span v-else v-text="$auth.user.initials" />
              </v-avatar>
              <div class="mr-1 text-truncate">
                {{ $auth.user.firstname }} {{ $auth.user.lastname }}
              </div>
            </div>
          </template>
          <template v-else>
            Zaloguj się
          </template>
        </v-btn>
      </div>
    </v-container>
  </v-app-bar>
  <v-navigation-drawer
    v-if="$vuetify.display.smAndDown"
    v-model="drawer"
    disable-resize-watcher
    disable-route-watcher
    location="start"
    touchless
    :scrim="false"
    :width="drawerWidth"
    :style="{
      backdropFilter: 'blur(8px)',
      background: 'rgba(242, 243, 247, 0.8) !important',
    }"
  >
    <div class="d-flex flex-column mt-8 ga-4">
      <v-btn
        v-for="item in menu"
        :key="item.text"
        variant="plain"
        :to="isInternal(item.url) ? item.url : undefined"
        :href="!isInternal(item.url) ? item.url : undefined"
        :target="!isInternal(item.url) ? '_blank' : undefined"
        :rel="!isInternal(item.url) ? 'noopener' : undefined"
        :text="item.text"
        exact
        :ripple="false"
        size="x-large"
        class="text-h6 font-weight-medium"
        @click="drawer = false"
      />
    </div>
  </v-navigation-drawer>
</template>
